import * as actions from '../actionTypes'
const initialState  = [];

const paymentRecordsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_PAYMENT_RECORD:
            return state.filter((paymentRecord) => paymentRecord._id !== action.payload);
        case actions.SET_PAYMENT_RECORDS:
            return action.payload;
        case actions.ADD_PAYMENT_RECORD:
            return [...state, action.payload];
        case actions.UPDATE_PAYMENT_RECORD: {
            return state.map((paymentRecord) => paymentRecord._id === action.payload._id ? action.payload : paymentRecord);
        }
        default:
            return state;
    }
};

export default paymentRecordsReducer;

  